module.exports = ".button-bar {\n  margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-edit-location-id/dialog-edit-location-id.component.scss
// module id = ./src/app/shared/dialog-edit-location-id/dialog-edit-location-id.component.scss
// module chunks = main